import React from 'react';
import questionsTheme from './questionsTheme';

const QuizHeader = ({ resultsMap, currentQuestion, onSelectQuestion, frontierIndex }) => {
    const resultsArray = Object.values(resultsMap || {});

    return (
        <div className="flexRow flexWrap smallGap margin-b--m" style={{ alignItems: 'center' }}>
            {resultsArray.map((q, index) => {
                const isSelected = currentQuestion?.questionId === q.questionId;
                const isAccessible = index <= frontierIndex; // Check if it's within the frontier

                // Determine the status background color
                let bgColor = questionsTheme.unmarkedGray;
                let textColor = '#333';

                if (q.result === true) {
                    bgColor = questionsTheme.correctGreen;
                    textColor = '#fff';
                } else if (q.result === false) {
                    bgColor = questionsTheme.incorrectRed;
                    textColor = '#fff';
                }

                return (
                    <button
                        key={q.questionId}
                        onClick={() => isAccessible && onSelectQuestion(q.questionId)}
                        disabled={!isAccessible}
                        className="ch-resultMarker-btn"
                        aria-label={`Question ${index + 1}`}
                        aria-current={isSelected ? "step" : undefined}
                        style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: bgColor,
                            color: textColor,
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            border: 'none',
                            boxShadow: isSelected
                                ? `0 0 0 2px #fff, 0 0 0 5px ${questionsTheme.primaryTeal}`
                                : 'none',
                            transition: 'all 0.2s ease-in-out',
                            margin: isSelected ? '4px' : '0',
                            // Add visual lock for inaccessible questions
                            cursor: isAccessible ? 'pointer' : 'not-allowed',
                            opacity: isAccessible ? 1 : 0.4
                        }}
                    >
                        {index + 1}
                    </button>
                );
            })}
        </div>
    );
};

export default QuizHeader;